export default "__VITE_ASSET__B6zqU9OH__"